import React, { useState } from "react";
import API from "../../../api.js";
import { Button, Form } from "react-bootstrap";
import { showToast } from "../../ToastMessage.jsx";

const ReportGenerator = ({ filters = {} }) => {
  const [loading, setLoading] = useState(false);

  const handleGenerate = async () => {
    try {
      setLoading(true);
      const { data } = await API.get("/admin/appointments/report", {
        params: filters,
      });
      if (!data || !data.length) {
        showToast("No data for selected filters", "error");
        setLoading(false);
        return;
      }
      // create print window with table (same HTML as before)
      const printWindow = window.open("", "_blank");
      printWindow.document.title = "Appointments Report";
      printWindow.document.body.style.fontFamily =
        "'Segoe UI', Tahoma, Verdana";
      printWindow.document.body.style.margin = "20px";

      const tableHTML = `
        <h2>🏥 Zainab Medical & Children Care Centre  - Appointments Report</h2>
        <p>Generated at: ${new Date().toLocaleString()}</p>
        <table style="width:100%; border-collapse: collapse; margin-top: 10px; font-size: 14px;">
          <thead>
            <tr style="background-color:#f0f0f0;">
              <th style="border:1px solid #ccc; padding:8px;">MR-Code</th>
              <th style="border:1px solid #ccc; padding:8px;">Patient</th>
              <th style="border:1px solid #ccc; padding:8px;">Department</th>
              <th style="border:1px solid #ccc; padding:8px;">Date</th>
              <th style="border:1px solid #ccc; padding:8px;">Time</th>
              <th style="border:1px solid #ccc; padding:8px;">Doctor</th>
              <th style="border:1px solid #ccc; padding:8px;">Status</th>
            </tr>
          </thead>
          <tbody>
            ${data
              .map(
                (appt, idx) => `
              <tr style="background-color:${
                idx % 2 === 0 ? "#fff" : "#f9f9f9"
              };">
              <td style="border:1px solid #ccc; padding:6px;">${
                  appt.mrCode
                }</td>
                <td style="border:1px solid #ccc; padding:6px;">${
                  appt.pName
                }</td>
                <td style="border:1px solid #ccc; padding:6px;">${
                  appt.department
                }</td>
                <td style="border:1px solid #ccc; padding:6px;">${
                  appt.date || "-"
                }</td>
                <td style="border:1px solid #ccc; padding:6px;">${
                  appt.time || "-"
                }</td>
                <td style="border:1px solid #ccc; padding:6px;">${
                  appt.doctor?.name || "Unassigned"
                }</td>
                <td style="border:1px solid #ccc; padding:6px;">${
                  appt.status || "-"
                }</td>
              </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        <div style="margin-top:30px; text-align:center; font-size:12px; color:#555;">Zainab Medical & Children Care Centre  © ${new Date().getFullYear()}</div>
      `;
      printWindow.document.body.innerHTML = tableHTML;
      printWindow.print();
      setLoading(false);
    } catch (err) {
      showToast(
        err.response?.data?.msg || err.message || "Failed to generate report",
        "error"
      );
      setLoading(false);
    }
  };

  return (
    <div>
      <Button
        variant="outline-primary"
        onClick={handleGenerate}
        disabled={loading}
      >
        {loading ? (
          "Generating..."
        ) : (
          <>
            <i className="bi bi-printer me-1"></i> Generate Report
          </>
        )}
      </Button>
    </div>
  );
};

export default ReportGenerator;
